import { Component, OnInit, OnDestroy, signal, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { VOneCarouselSlide } from '@shared-models';

@Component({
  selector: 'app-v-one-carousel',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './v-one-carousel.component.html',
  styleUrls: ['./v-one-carousel.component.scss'],
})
export class VOneCarouselComponent implements OnInit, OnDestroy {
  slides = input<VOneCarouselSlide[]>([]);
  autoSlide = input<boolean>(true);
  slideInterval = input<number>(5000);
  showIndicators = input<boolean>(true);

  readonly activeSlideIndex = signal<number>(0);

  private intervalId: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    if (this.autoSlide() && this.slides().length > 1) {
      this.startCarousel();
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  setActiveSlide(index: number): void {
    if (index >= 0 && index < this.slides().length) {
      this.activeSlideIndex.set(index);
    }
  }

  private startCarousel(): void {
    this.intervalId = setInterval(() => {
      const nextSlide = (this.activeSlideIndex() + 1) % this.slides().length;
      this.setActiveSlide(nextSlide);
    }, this.slideInterval());
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target) {
      target.src = 'assets/img/cantfindimage.jpg';
    }
  }

  private isValidImageUrl(url: string): boolean {
    return (
      url.includes('assets/') ||
      url.startsWith('http') ||
      url.startsWith('https')
    );
  }

  getImageUrl(url: string): string {
    return this.isValidImageUrl(url) ? url : 'assets/img/cantfindimage.jpg';
  }
}
